import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import LocalisedMessage from 'components/Common/LocalisedMessage';
import ErrorPage from 'components/Errors/ErrorPage';
import { history } from 'containers/App';

const InsufficientFormInformationError = ({ showButton }) => <ErrorPage
  showButton={ showButton }
  type="server"
  title="Insufficient Information"
  onButtonClick={ history.goBack }
  buttonTextId="insufficientFormInformation.buttonText"
  titleTextId="insufficientFormInformation.title"
>
  <LocalisedMessage id="insufficientFormInformation.content" />
</ErrorPage>;

InsufficientFormInformationError.propTypes = {
  showButton: PropTypes.bool,
};
InsufficientFormInformationError.defaultProps = {
  showButton: true,
};

function mapStateToProps(state) {
  const {
    app: { onlineConfig },
  } = state;

  const activeFormTypes = onlineConfig?.formTypes?.filter(x => x.isEnabled && x.isVisible) ?? [];
  const activeFormGroups = onlineConfig?.formGroups?.filter(x => x.isEnabled && x.isVisible) ?? [];

  const showButton = activeFormTypes.length + activeFormGroups.length > 1;

  return {
    showButton,
  };
}

export default connect(mapStateToProps)(InsufficientFormInformationError);
